import {useTheme} from "@material-ui/core";


function useDimension() {
    const theme = useTheme();

    const htmlFontSize = window.parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('font-size'));

    const formControlHeight = ({size, margin, variant} = {}) => {
        // font-size * line-height + paddingX * 2
        let height = htmlFontSize * 1.1876 + 18.5 * 2;
        return height;
    }

    const toolbarHeight = () => {
        let height = theme.mixins.toolbar.height;
        return height;
    }

    const spacing = (count) => {
        theme.spacing(count);
    }

    return {formControlHeight, toolbarHeight, spacing}
}

export default useDimension;